import { getSpecialPriceTargetPuidForAdFox } from '../../../utils/adfox';
import { IState } from '../../index';

export function selectAdfoxRequestedParams(state: IState) {
  const { offer } = state.offerData;

  return { ...state.adfoxParams, puid6: getSpecialPriceTargetPuidForAdFox(offer.bargainTerms.prices.rur) };
}
